import React, { useState, useEffect } from "react";
import { useSearchParams } from 'react-router-dom';
import Datapoint from "../datapoint/datapointV2";
import {getDatasetByUUID} from "../../indexDB/utils/dataset" 
import Sync from "./Sync"
import {loadForms} from "./LoadForms"
import LoadingSpinner from './LoadingSpinner';
import MagicUrlDatapoint from "./MagicUrlDatapoint";
import config from "../../config";
export default function MagicUrl ({handleLogout}){
    const [searchParams, setSearchParams] = useSearchParams();
    const [dataset,setDataset] = useState(null);
    const [submit, setSubmit] = useState(false);
    const [datapointID, setDatapointId] = useState(null);
    const currentDomain = process.env.REACT_APP_DOMAIN;
    const domainConfig = config[currentDomain];
    const endpoint = domainConfig.apiEndpoint;
    
    useEffect(() => {
        const loadForm = async () => {

            const shortId = searchParams.get('id');
            const url_endpoint = endpoint + `/project/decode-magic-url/?id=${shortId}`;

            try {
                const response = await fetch(url_endpoint, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const response_data = await response.json();
                const dataset_id = response_data.dataset_id;
                const token = response_data.token;  
                await loadForms(token);

                console.log("fetched forms")
                const data =  await getDatasetByUUID(dataset_id);
                localStorage.setItem("dataset_id", data.id);
                setDataset(data)

            } catch (error) {
                console.error("Error fetching magic URL data:", error);
                throw error;
            }

        }
        loadForm();        
      }, []);

    if (!dataset) {
        return <LoadingSpinner message="Your forms are loading"/>
      }

    return (
        <>
         <MagicUrlDatapoint dataset={dataset} handleLogout={handleLogout} setSubmit={setSubmit} setDatapointId={setDatapointId}/>
        </>

    );
} 
